"use client";

import { PageError } from "@up/ui";

export default function Error() {
  return <PageError />;
}
